<template>
  <div class="sharper-container">
    <!-- 上部分 -->
    <div class="sharper-top-section">
      <div class="top-left">
        <img v-if="this.$i18n.locale === 'zh'" style="width: 80%;" src="../../static/series/SharperingSystem/sharp2.png"
             class="text-image"/>
        <img v-else style="width: 80%;" src="../../static/series/SharperingSystem/sharp2-1.png"
             class="text-image"/>
      </div>
      <div class="top-right">
        <img src="../../static/series/SharperingSystem/sharp3.png" class="sharper-product-image"/>
      </div>
    </div>

    <!-- 下部分 -->
    <div class="bottom-section">
      <div class="sharper-question-text">{{ $t('series.sandingBelts') }}</div>
      <div class="sharpencards-section">
        <div class="sharpencard" v-for="(sharpencard, index) in sharpencards" :key="index" :ref="`sharper_${index}`">
          <img :src="sharpencard.imageUrl" class="sharpencard-image"/>
          <div class="sharpencard-content">
            <div class="sharpencard-title">{{ sharpencard.title }}</div>
            <div class="sharpencard-desc">{{ sharpencard.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sharp from "../../static/series/SharperingSystem/sharp.png";
import sharp1 from "../../static/series/SharperingSystem/sharp1.png";
import sharp2 from "../../static/series/SharperingSystem/图片11.png";
import sharp3 from "../../static/series/SharperingSystem/图片12.png";
import sharp4 from "../../static/series/SharperingSystem/sharp11-1.png";
import sharp5 from "../../static/series/SharperingSystem/sharp12-1.png";

export default {
  name: "SharpeningSystem",
  data() {
    return {
      sharpencards: [
        {
          imageUrl: sharp,
          title: this.$i18n.t('series.sharpTime'),
          description:this.$i18n.t('series.sharpTimeDesc'),
        },
        {
          imageUrl: sharp1,
          title: this.$i18n.t('series.sharpWidth'),
          description: this.$i18n.t('series.sharpWidthDesc'),
        },
        {
          imageUrl: sharp2,
          title: this.$i18n.t('series.sharpBelts'),
          description: this.$i18n.t('series.sharpBeltsDesc'),
        },
        {
          imageUrl: sharp3,
          title: this.$i18n.t('series.sharpKnife'),
          description: this.$i18n.t('series.sharpKnifeDesc'),
        },
      ],
      isMobile: false,
      timeline: null
    };
  },
  mounted() {
    if (this.$i18n.locale === 'en'){
      this.sharpencards[2].imageUrl = sharp4
      this.sharpencards[3].imageUrl = sharp5
    }

    // 检测设备类型
    this.checkDeviceType();
    this.$nextTick(() => {
      this.initAnimation();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    checkDeviceType() {
      // 检测是否为移动设备
      this.isMobile = window.innerWidth < 768;
    },
    initAnimation() {
      // 获取所有需要动画的元素
      const topSection = document.querySelector('.sharper-top-section');
      const questionText = document.querySelector('.sharper-question-text');
      // const sharpencards = this.sharpencards.map((_, index) => this.$refs[`sharper_${index}`][0]);

      // 设置初始状态，手机端初始位移更小
      this.$gsap.set([topSection, questionText], {
        opacity: 0,
        y: this.isMobile ? 30 : 50
      });

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.top-left',
          start: this.isMobile ? 'top 60%' : 'top 85%',
          end: this.isMobile ? 'bottom 30%' : 'bottom -20%',
          toggleActions: 'play none none none',
          markers: false,
          once: true,
          // scrub: 2,
        }
      });

      // 顶部区域动画
      masterTimeline.to(topSection, {
        opacity: 1,
        y: 0,
        duration: this.isMobile ? 0.8 : 1,
        ease: 'power2.out'
      }, 0);

      // 问题文本动画
      masterTimeline.to(questionText, {
        opacity: 1,
        y: 0,
        duration: this.isMobile ? 0.8 : 1,
        ease: 'power2.out'
      }, this.isMobile ? 0.2 : 0.3);

      // 卡片动画 - 按顺序显示
      // sharpencards.forEach((sharpencard, index) => {
      //   masterTimeline.to(sharpencard, {
      //     opacity: 1,
      //     y: 0,
      //     delay: 0.8,
      //     duration: this.isMobile ? 0.7 : 0.8,
      //     ease: 'power2.out'
      //   }, this.isMobile ? (0.3 + index * 0.15) : (index * 0.2));
      // });

      // 图片向上移动
      masterTimeline.to('.top-right', {
        y: -320,
        // opacity: 0,
        duration: 1.5,
        ease: 'power2.in'
      }, 1)

      // 字体颜色修改
      masterTimeline.to('.sharper-question-text', {
        duration: 1.5,
        color: "#ffffff",
        ease: "power2.in"
      }, 1)

      masterTimeline.to('.bottom-section', {
        duration: 1.5,
        scaleX: 1.1,
        ease: "power2.in",
        y: "-20vw",
        x: "8vw"
      }, 1)

      masterTimeline.to('.sharpencards-section', {
        duration: 2,
        ease: "power2.in",
        x: "-15vw"
      }, 3)

      // masterTimeline.to('.sharper-container', {
      //   opacity: 0,
      //   y: -200,
      //   delay: 2,
      //   duration: this.isMobile ? 0.8 : 1.5,
      //   ease: 'power2.out'
      // }, 3);

    }
  }
};
</script>

<style scoped>
.sharper-container {
  display: flex;
  height: 1500px;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #000;
  margin-top: 200px;
}

/* 上部分样式 */
.sharper-top-section {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 20px;
  align-items: center;
}

.top-left {
  width: 100%;
}

.top-right {
  width: 100%;
}

.text-image,
.sharper-product-image {
  width: 75%;
  height: auto;
}

/* 下部分样式 */
.bottom-section {
  height: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
}

.sharper-question-text {
  width: 100%;
  text-align: left;
  font-size: 1.4em;
  margin-bottom: 20px;
  color: #808080;
}

.sharpencards-section {
  width: 130%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.sharpencard {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #161617;
  border-radius: 30px;
  width: 500px;

}

.sharpencard-image {
  width: 100%;
  height: 100%;
  margin-bottom: 60px;
}

.sharpencard-content {
  text-align: left;
  margin-bottom: 50px;
  width: 80%;
}

.sharpencard-title {
  font-size: 1.4em;
  color: white;
  margin-bottom: 5px;
}

.sharpencard-desc {
  font-size: 1.4em;
  color: white;
}

/* 手机端适配样式 */
@media (max-width: 767px) {
  .container {
    padding: 15px;
  }

  /* 上部分样式调整 */
  .sharper-top-section {
    flex-direction: column; /* 改为垂直布局 */
    width: 100%;
    gap: 20px;
  }

  .top-left,
  .top-right {
    width: 100%;
    display: flex;
    justify-content: center; /* 图片居中 */
  }

  .text-image,
  .sharper-product-image {
    width: 80%; /* 图片放大 */
  }

  /* 下部分样式调整 */
  .bottom-section {
    height: auto; /* 自动适应内容高度 */
    width: 100%;
    padding: 10px 0;
  }

  .sharper-question-text {
    font-size: 1.1em;
    text-align: center; /* 问题文本居中 */
    margin-bottom: 30px;
    padding: 0 5%;
  }

  .sharpencards-section {
    flex-direction: column; /* 卡片改为垂直排列 */
    align-items: center;
    gap: 25px;
  }

  .sharpencard {
    width: 90%; /* 卡片占满宽度 */
    max-width: 300px;
  }

  .sharpencard-content {
    padding: 0 15px; /* 增加内边距 */
  }

  .sharpencard-title {
    font-size: 1.1em;
  }

  .sharpencard-desc {
    font-size: 0.95em;
    line-height: 1.6; /* 增加行高提高可读性 */
  }
}
</style>

